export const soupItems = [
  {
    id: 1,
    alb: "Supë Dite",
    ita: "Zuppa del Giorno",
    eng: "Soup of the Day",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "350",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
  {
    id: 2,
    alb: "Supë Pule",
    ita: "Zuppa di Pollo",
    eng: "Chicken Soup",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "450",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
  {
    id: 3,
    alb: "Supë Viçi",
    ita: "Zuppa di Manzo",
    eng: "Beef Soup",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "550",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
 {
    id: 44430,
    alb: "Fokace",
    ita: "Focaccia",
    eng: "Fokace",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "100",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
  {
    id: 44431,
    alb: "Fokace me Djathë",
    ita: "Focaccia al formaggio",
    eng: "Focaccia with cheese",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "250",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
  {
    id: 44432,
    alb: "Fokace Domate Kastravec Djath",
    ita: "Focaccia al pomodoro, cetriolo e formaggio",
    eng: "Tomato Cucumber Cheese Focaccia",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "400",
    kat: 1,
    linkAlb: "/supa",
    linkIta: "/zuppe",
    linkEng: "/soups",
  },
];
export const sallataItems = [
 {
    id: 7,
    alb: "Sallatë Spinaq Panxhar",
    ita: "Insalata di Spinaci e Barbabietola",
    eng: "Spinach & Beetroot Salad",
    ingAlb: "Karrota, finok, djathë i bardhë, pomodorini",
    ingIta: "Carote, finocchio, formaggio bianco, pomodorini",
    ingEng: "Carrot, fennel, white cheese, cherry tomatoes",
    price: "700",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 8,
    alb: "Sallatë Mix",
    ita: "Insalata Mista",
    eng: "Mixed Salad",
    ingAlb: "Brie, fileto pule, pomodorini, dressing",
    ingIta: "Brie, filetto di pollo, pomodorini, dressing",
    ingEng: "Brie, chicken fillet, cherry tomatoes, dressing",
    price: "800",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 9,
    alb: "Sallatë Bresaola",
    ita: "Insalata Bresaola",
    eng: "Bresaola Salad",
    ingAlb: "Mix gjethesh, pomodorini, grana, bresaola, majonezë tartufi",
    ingIta: "Mix di foglie, pomodorini, grana, bresaola, maionese al tartufo",
    ingEng: "Mixed leaves, cherry tomatoes, grana, bresaola, truffle mayonnaise",
    price: "850",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 10,
    alb: "Sallatë Dardhë Gorgonzola",
    ita: "Insalata Pera e Gorgonzola",
    eng: "Pear & Gorgonzola Salad",
    ingAlb: "Mix gjethesh, dardhë, arra, gorgonzola, dressing",
    ingIta: "Mix di foglie, pera, noci, gorgonzola, dressing",
    ingEng: "Mixed leaves, pear, walnuts, gorgonzola, dressing",
    price: "800",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 11,
    alb: "Sallatë Rukola Mozzarella",
    ita: "Insalata Rucola e Mozzarella",
    eng: "Arugula & Mozzarella Salad",
    ingAlb: "Rukola, pomodorini, arra, mozzarella, kërpudha, dressing",
    ingIta: "Rucola, pomodorini, noci, mozzarella, funghi, dressing",
    ingEng: "Arugula, cherry tomatoes, walnuts, mozzarella, mushrooms, dressing",
    price: "750",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
  {
    id: 12,
    alb: "Sallatë Cezar",
    ita: "Insalata Caesar",
    eng: "Caesar Salad",
    ingAlb: "Iceberg, fileto pule, misër, salcë Cezar",
    ingIta: "Iceberg, filetto di pollo, mais, salsa Caesar",
    ingEng: "Iceberg, chicken fillet, corn, Caesar sauce",
    price: "750",
    kat: 3,
    linkAlb: "/sallata",
    linkIta: "/insalate",
    linkEng: "/salads",
  },
];
export const antipastaItems = [
    {
    id: 13,
    alb: "Antipastë e Ngrohtë",
    ita: "Antipasto Caldo",
    eng: "Warm Antipasto",
    ingAlb: "Salcice, fasule, speca, salcë e kuqe, qepë",
    ingIta: "Salsiccia, fagioli, peperoni, salsa rossa, cipolla",
    ingEng: "Sausage, beans, peppers, red sauce, onion",
    price: "750",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 14,
    alb: "Kërpudha Sote",
    ita: "Funghi Sauté",
    eng: "Sautéed Mushrooms",
    ingAlb: "Kërpudha, krem djathi, peperoncini",
    ingIta: "Funghi, crema di formaggio, peperoncino",
    ingEng: "Mushrooms, cream cheese, chili pepper",
    price: "700",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 15,
    alb: "Karkalec Saganaq",
    ita: "Gamberi Saganaki",
    eng: "Shrimp Saganaki",
    ingAlb: "Pomodoro, karkalec, vaj hudhre, salcë",
    ingIta: "Pomodoro, gamberi, olio all'aglio, salsa",
    ingEng: "Tomato, shrimp, garlic oil, sauce",
    price: "900",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 16,
    alb: "Kroketa Pule",
    ita: "Crocchette di Pollo",
    eng: "Chicken Croquettes",
    ingAlb: "Fileto pule",
    ingIta: "Filetto di pollo",
    ingEng: "Chicken fillet",
    price: "700",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 17,
    alb: "Antipastë Roma",
    ita: "Antipasto Roma",
    eng: "Roma Antipasto",
    ingAlb: "Mix djathrash, mix proshutash",
    ingIta: "Mix di formaggi, mix di salumi",
    ingEng: "Cheese mix, cured meat mix",
    price: "1600",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 18,
    alb: "Kroketa Mozzarella",
    ita: "Crocchette di Mozzarella",
    eng: "Mozzarella Croquettes",
    ingAlb: "Mozzarella",
    ingIta: "Mozzarella",
    ingEng: "Mozzarella",
    price: "700",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 19,
    alb: "Qofte Shtëpie",
    ita: "Polpette della Casa",
    eng: "Homemade Meatballs",
    ingAlb: "Mish viçi, qepë, salcë",
    ingIta: "Carne di manzo, cipolla, salsa",
    ingEng: "Beef, onion, sauce",
    price: "950",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 20,
    alb: "Salcice Krem Djathi",
    ita: "Salsiccia con Crema di Formaggio",
    eng: "Sausage with Cream Cheese",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "800",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 21,
    alb: "Burrata DIP",
    ita: "Burrata DIP",
    eng: "Burrata DIP",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "950",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
  {
    id: 22,
    alb: "Pjatë Birre",
    ita: "Piatto Birra",
    eng: "Beer Platter",
    ingAlb: "Fileto pule, speca, qepë, sriracha",
    ingIta: "Filetto di pollo, peperoni, cipolla, sriracha",
    ingEng: "Chicken fillet, peppers, onion, sriracha",
    price: "950",
    kat: 4,
    linkAlb: "/antipasta",
    linkIta: "/antipaste",
    linkEng: "/appetizers",
  },
];
export const rizotoItems = [
  {
    id: 23,
    alb: "Rizoto Milanese Kontrafileto",
    ita: "Risotto Milanese con Controfiletto",
    eng: "Milanese Risotto with Sirloin",
    ingAlb: "Kontrafileto, zaferano, pomodorini, majdanoz",
    ingIta: "Controfiletto, zafferano, pomodorini, prezzemolo",
    ingEng: "Sirloin, saffron, cherry tomatoes, parsley",
    price: "900",
    kat: 5,
    linkAlb: "/risoto",
    linkIta: "/rissoto",
    linkEng: "/risotto-eng",
  },
  {
    id: 24,
    alb: "Rizoto Salcice",
    ita: "Risotto con Salsiccia",
    eng: "Sausage Risotto",
    ingAlb: "Salcice, brokoli, pomodorini, majdanoz",
    ingIta: "Salsiccia, broccoli, pomodorini, prezzemolo",
    ingEng: "Sausage, broccoli, cherry tomatoes, parsley",
    price: "850",
    kat: 5,
    linkAlb: "/risoto",
    linkIta: "/rissoto",
    linkEng: "/risotto-eng",
  },
  {
    id: 25,
    alb: "Rizoto Gorgonzola",
    ita: "Risotto al Gorgonzola",
    eng: "Gorgonzola Risotto",
    ingAlb: "Dardhë, gorgonzola, arra, krem fresh",
    ingIta: "Pera, gorgonzola, noci, crème fraîche",
    ingEng: "Pear, gorgonzola, walnuts, crème fraîche",
    price: "850",
    kat: 5,
    linkAlb: "/risoto",
    linkIta: "/rissoto",
    linkEng: "/risotto-eng",
  },
  {
    id: 26,
    alb: "Rizoto Karkalec & Karçof",
    ita: "Risotto Gamberi e Carciofi",
    eng: "Shrimp & Artichoke Risotto",
    ingAlb: "Karkalec, karçof, pomodorini, majdanoz",
    ingIta: "Gamberi, carciofi, pomodorini, prezzemolo",
    ingEng: "Shrimp, artichoke, cherry tomatoes, parsley",
    price: "950",
    kat: 5,
    linkAlb: "/risoto",
    linkIta: "/rissoto",
    linkEng: "/risotto-eng",
  },
];
export const pastaItems = [
 {
    id: 27,
    alb: "Pasta Salcice & Gorgonzola",
    ita: "Pasta Salsiccia e Gorgonzola",
    eng: "Sausage & Gorgonzola Pasta",
    ingAlb: "Salcice, gorgonzola, salcë rozë, grana",
    ingIta: "Salsiccia, gorgonzola, salsa rosa, grana",
    ingEng: "Sausage, gorgonzola, pink sauce, grana",
    price: "850",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 28,
    alb: "Ravioli Guanciale",
    ita: "Ravioli al Guanciale",
    eng: "Guanciale Ravioli",
    ingAlb: "Krem kungulli, guanciale, grana, pomodorini",
    ingIta: "Crema di zucca, guanciale, grana, pomodorini",
    ingEng: "Pumpkin cream, guanciale, grana, cherry tomatoes",
    price: "950",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 29,
    alb: "Pasta Fileto Viçi",
    ita: "Pasta con Filetto di Manzo",
    eng: "Beef Fillet Pasta",
    ingAlb: "Fileto viçi, tartuf, grana, krem fresh",
    ingIta: "Filetto di manzo, tartufo, grana, crème fraîche",
    ingEng: "Beef fillet, truffle, grana, crème fraîche",
    price: "1000",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 30,
    alb: "Tagliatele Grande Roma",
    ita: "Tagliatelle Grande Roma",
    eng: "Grande Roma Tagliatelle",
    ingAlb: "Fileto viçi, kërpudha, grana, majdanoz, salcë e kuqe",
    ingIta: "Filetto di manzo, funghi, grana, prezzemolo, salsa rossa",
    ingEng: "Beef fillet, mushrooms, grana, parsley, red sauce",
    price: "1050",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 31,
    alb: "Pasta Porcini",
    ita: "Pasta ai Porcini",
    eng: "Porcini Pasta",
    ingAlb: "Porcini, pomodorini, majdanoz, grana",
    ingIta: "Porcini, pomodorini, prezzemolo, grana",
    ingEng: "Porcini mushrooms, cherry tomatoes, parsley, grana",
    price: "1250",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 32,
    alb: "Pasta Gallina",
    ita: "Pasta al Pollo",
    eng: "Chicken Pasta",
    ingAlb: "Pulë, krem djathi, kërpudha, salcë, grana",
    ingIta: "Pollo, crema di formaggio, funghi, salsa, grana",
    ingEng: "Chicken, cream cheese, mushrooms, sauce, grana",
    price: "950",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 33,
    alb: "Green Pasta",
    ita: "Pasta Verde",
    eng: "Green Pasta",
    ingAlb: "Krem mix gjethesh",
    ingIta: "Crema di misticanza",
    ingEng: "Mixed greens cream",
    price: "900",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 34,
    alb: "Pasta Bresaola",
    ita: "Pasta alla Bresaola",
    eng: "Bresaola Pasta",
    ingAlb: "Bresaola, speca, pomodorini, salcë, grana",
    ingIta: "Bresaola, peperoni, pomodorini, salsa, grana",
    ingEng: "Bresaola, peppers, cherry tomatoes, sauce, grana",
    price: "950",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
  {
    id: 35,
    alb: "Tris Pastash",
    ita: "Tris di Pasta",
    eng: "Pasta Trio",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "2400",
    kat: 6,
    linkAlb: "/pasta",
    linkIta: "/paste",
    linkEng: "/pastas",
  },
];
export const secondiItems = [
{
    id: 36,
    alb: "Fileto Viçi Zgare",
    ita: "Filetto di Manzo alla Griglia",
    eng: "Grilled Beef Fillet",
    ingAlb: "Patate furre / perime të ziera",
    ingIta: "Patate al forno / verdure lesse",
    ingEng: "Roasted potatoes / boiled vegetables",
    price: "2200",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 37,
    alb: "Fileto Viçi Primavera",
    ita: "Filetto di Manzo Primavera",
    eng: "Primavera Beef Fillet",
    ingAlb: "Fileto viçi, spinaq sote, pomodori, kërpudha",
    ingIta: "Filetto di manzo, spinaci saltati, pomodoro, funghi",
    ingEng: "Beef fillet, sautéed spinach, tomato, mushrooms",
    price: "2200",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 38,
    alb: "Fileto Viçi Brandy",
    ita: "Filetto di Manzo al Brandy",
    eng: "Brandy Beef Fillet",
    ingAlb: "Fileto viçi, kërpudha, salcë, speca",
    ingIta: "Filetto di manzo, funghi, salsa, peperoni",
    ingEng: "Beef fillet, mushrooms, sauce, peppers",
    price: "2200",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 39,
    alb: "Tagliata",
    ita: "Tagliata",
    eng: "Tagliata",
    ingAlb: "Rukola, grana, pomodorini",
    ingIta: "Rucola, grana, pomodorini",
    ingEng: "Arugula, grana, cherry tomatoes",
    price: "1550",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 40,
    alb: "Bërxollë Viçi",
    ita: "Bistecca di Manzo",
    eng: "Beef Steak",
    ingAlb: "Patate furre",
    ingIta: "Patate al forno",
    ingEng: "Roasted potatoes",
    price: "1300",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 41,
    alb: "Peskaviçe Viçi",
    ita: "Pescavice di Manzo",
    eng: "Beef Peskavice",
    ingAlb:"Djathë i bardhë / djathë furre / patate furre / pure patate / perime sote",
    ingIta:"Formaggio bianco / formaggio al forno / patate al forno / purè / verdure saltate",
    ingEng:"White cheese / baked cheese / roasted potatoes / mashed potatoes / sautéed vegetables",
    price: "1150",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 42,
    alb: "Salcice Viçi",
    ita: "Salsiccia di Manzo",
    eng: "Beef Sausage",
    ingAlb:"Djathë i bardhë / djathë furre / patate furre / pure patate / perime sote",
    ingIta:"Formaggio bianco / formaggio al forno / patate al forno / purè / verdure saltate",
    ingEng:"White cheese / baked cheese / roasted potatoes / mashed potatoes / sautéed vegetables",
    price: "1050",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 43,
    alb: "Fileto Pule",
    ita: "Filetto di Pollo",
    eng: "Chicken Fillet",
    ingAlb: "Perime të ziera / patate furre",
    ingIta: "Verdure lesse / patate al forno",
    ingEng: "Boiled vegetables / roasted potatoes",
    price: "950",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 44,
    alb: "Salmon Chef",
    ita: "Salmone Chef",
    eng: "Chef's Salmon",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "1500",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
  {
    id: 45,
    alb: "Mix Mish",
    ita: "Misto di Carne",
    eng: "Mixed Meat",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "3400",
    kat: 7,
    linkAlb: "/pjata-kryesore",
    linkIta: "/secondi-piatti",
    linkEng: "/main-dishes",
  },
];
export const pizzaItems = [
{
    id: 46,
    alb: "Margherita",
    ita: "Margherita",
    eng: "Margherita",
    ingAlb: "Salcë domatesh, mozzarella",
    ingIta: "Salsa di pomodoro, mozzarella",
    ingEng: "Tomato sauce, mozzarella",
    price: "650",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 47,
    alb: "Diavola",
    ita: "Diavola",
    eng: "Diavola",
    ingAlb: "Salcë domatesh, mozzarella, sallam pikant",
    ingIta: "Salsa di pomodoro, mozzarella, salame piccante",
    ingEng: "Tomato sauce, mozzarella, spicy salami",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 48,
    alb: "Proshutë",
    ita: "Prosciutto",
    eng: "Ham",
    ingAlb: "Salcë domatesh, mozzarella, proshutë",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto",
    ingEng: "Tomato sauce, mozzarella, ham",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 49,
    alb: "Kërpudhë",
    ita: "Funghi",
    eng: "Mushroom",
    ingAlb: "Salcë domatesh, mozzarella, kërpudha",
    ingIta: "Salsa di pomodoro, mozzarella, funghi",
    ingEng: "Tomato sauce, mozzarella, mushrooms",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 50,
    alb: "Proshutë Kërpudhë",
    ita: "Prosciutto e Funghi",
    eng: "Ham & Mushroom",
    ingAlb: "Salcë domatesh, mozzarella, proshutë, kërpudhë",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto, funghi",
    ingEng: "Tomato sauce, mozzarella, ham, mushrooms",
    price: "850",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 51,
    alb: "Proshutë Sallam",
    ita: "Prosciutto e Salame",
    eng: "Ham & Salami",
    ingAlb: "Salcë domatesh, mozzarella, proshutë, sallam",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto, salame",
    ingEng: "Tomato sauce, mozzarella, ham, salami",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 52,
    alb: "Capricciosa",
    ita: "Capricciosa",
    eng: "Capricciosa",
    ingAlb: "Salcë domatesh, mozzarella, proshutë, kërpudhë, carciofi, sallam",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto, funghi, carciofi, salame",
    ingEng: "Tomato sauce, mozzarella, ham, mushrooms, artichokes, salami",
    price: "850",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 53,
    alb: "4 Stinët",
    ita: "4 Stagioni",
    eng: "4 Seasons",
    ingAlb: "Salcë domatesh, mozzarella, proshutë, kërpudhë, carciofi, ullinj",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto, funghi, carciofi, olive",
    ingEng: "Tomato sauce, mozzarella, ham, mushrooms, artichokes, olives",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 54,
    alb: "Ton",
    ita: "Tonno",
    eng: "Tuna",
    ingAlb: "Salcë domatesh, mozzarella, ton",
    ingIta: "Salsa di pomodoro, mozzarella, tonno",
    ingEng: "Tomato sauce, mozzarella, tuna",
    price: "850",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 55,
    alb: "Tonno Kërpudhë",
    ita: "Tonno e Funghi",
    eng: "Tuna & Mushroom",
    ingAlb: "Salcë domatesh, mozzarella, ton, kërpudhë",
    ingIta: "Salsa di pomodoro, mozzarella, tonno, funghi",
    ingEng: "Tomato sauce, mozzarella, tuna, mushrooms",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 56,
    alb: "Tonno Qepë",
    ita: "Tonno e Cipolla",
    eng: "Tuna & Onion",
    ingAlb: "Salcë domatesh, mozzarella, ton, qepë",
    ingIta: "Salsa di pomodoro, mozzarella, tonno, cipolla",
    ingEng: "Tomato sauce, mozzarella, tuna, onion",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 57,
    alb: "Ortolana",
    ita: "Ortolana",
    eng: "Vegetable",
    ingAlb: "Salcë domatesh, mozzarella, patëllxhan, kungull, spec, spinaq",
    ingIta: "Salsa di pomodoro, mozzarella, melanzana, zucchina, peperone, spinaci",
    ingEng: "Tomato sauce, mozzarella, eggplant, zucchini, pepper, spinach",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 58,
    alb: "Romana",
    ita: "Romana",
    eng: "Romana",
    ingAlb: "Salcë domatesh, mozzarella, açuge, kaperi",
    ingIta: "Salsa di pomodoro, mozzarella, acciughe, capperi",
    ingEng: "Tomato sauce, mozzarella, anchovies, capers",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 59,
    alb: "Albania",
    ita: "Albania",
    eng: "Albania",
    ingAlb: "Salcë domatesh, mozzarella, ricotta, spinaq, vezë",
    ingIta: "Salsa di pomodoro, mozzarella, ricotta, spinaci, uovo",
    ingEng: "Tomato sauce, mozzarella, ricotta, spinach, egg",
    price: "850",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 60,
    alb: "Wudy",
    ita: "Wudy",
    eng: "Wudy",
    ingAlb: "Salcë domatesh, mozzarella, Wudy",
    ingIta: "Salsa di pomodoro, mozzarella, Wudy",
    ingEng: "Tomato sauce, mozzarella, Wudy",
    price: "850",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },

{
    id: 62,
    alb: "Burrata",
    ita: "Burrata",
    eng: "Burrata",
    ingAlb: "Salcë domatesh, mozzarella, burrata, rukola, krudo, grana, pomodorini",
    ingIta: "Salsa di pomodoro, mozzarella, burrata, rucola, crudo, grana, pomodorini",
    ingEng: "Tomato sauce, mozzarella, burrata, arugula, crudo, grana, cherry tomatoes",
    price: "1100",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 63,
    alb: "Crudiaola",
    ita: "Crudiaola",
    eng: "Crudiaola",
    ingAlb: "Salcë domatesh, mozzarella, krudo, rukola, pomodorini, grana",
    ingIta: "Salsa di pomodoro, mozzarella, crudo, rucola, pomodorini, grana",
    ingEng: "Tomato sauce, mozzarella, crudo, arugula, cherry tomatoes, grana",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 64,
    alb: "Porcellona",
    ita: "Porcellona",
    eng: "Porcellona",
    ingAlb: "Salcë domatesh, mozzarella, pançetë, gorgonzola",
    ingIta: "Salsa di pomodoro, mozzarella, pancetta, gorgonzola",
    ingEng: "Tomato sauce, mozzarella, pancetta, gorgonzola",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 65,
    alb: "Brie",
    ita: "Brie",
    eng: "Brie",
    ingAlb: "Salcë domatesh, mozzarella, brie, pomodorini, speck",
    ingIta: "Salsa di pomodoro, mozzarella, brie, pomodorini, speck",
    ingEng: "Tomato sauce, mozzarella, brie, cherry tomatoes, speck",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 66,
    alb: "Filadelfia",
    ita: "Philadelphia",
    eng: "Philadelphia",
    ingAlb: "Salcë domatesh, mozzarella, filadelfia, pika tartufi, grana, proshutë cotto",
    ingIta: "Salsa di pomodoro, mozzarella, philadelphia, gocce di tartufo, grana, prosciutto cotto",
    ingEng: "Tomato sauce, mozzarella, Philadelphia, truffle drops, grana, cooked ham",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 67,
    alb: "Sboldra",
    ita: "Sboldra",
    eng: "Sboldra",
    ingAlb: "Salcë domatesh, bufala, sallam pikant, grana, rozmarinë",
    ingIta: "Salsa di pomodoro, bufala, salame piccante, grana, rosmarino",
    ingEng: "Tomato sauce, buffalo mozzarella, spicy salami, grana, rosemary",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 68,
    alb: "Siciliana",
    ita: "Siciliana",
    eng: "Siciliana",
    ingAlb: "Salcë domatesh, mozzarella, sallam pikant, açuge, gorgonzola",
    ingIta: "Salsa di pomodoro, mozzarella, salame piccante, acciughe, gorgonzola",
    ingEng: "Tomato sauce, mozzarella, spicy salami, anchovies, gorgonzola",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 69,
    alb: "Tre Desideri",
    ita: "Tre Desideri",
    eng: "Tre Desideri",
    ingAlb: "Salcë domatesh, mozzarella, proshutë krudo, proshutë cotto, speck, rukola, pomodorini",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto crudo, prosciutto cotto, speck, rucola, pomodorini",
    ingEng: "Tomato sauce, mozzarella, prosciutto crudo, cooked ham, speck, arugula, cherry tomatoes",
    price: "1000",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 70,
    alb: "Roma",
    ita: "Roma",
    eng: "Roma",
    ingAlb: "Salcë domatesh, bufala, pomodorini, rigon, borzilok, ullinj",
    ingIta: "Salsa di pomodoro, bufala, pomodorini, origano, basilico, olive",
    ingEng: "Tomato sauce, buffalo mozzarella, cherry tomatoes, oregano, basil, olives",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 71,
    alb: "Gallinaccio",
    ita: "Gallinaccio",
    eng: "Gallinaccio",
    ingAlb: "Salcë domatesh, mozzarella, pas pjekjes proshutë gjeli, pomodorini, grana",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto di tacchino dopo la cottura, pomodorini, grana",
    ingEng: "Tomato sauce, mozzarella, turkey ham after baking, cherry tomatoes, grana",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 72,
    alb: "Bresaola",
    ita: "Bresaola",
    eng: "Bresaola",
    ingAlb: "Salcë domatesh, mozzarella, bresaola, burrata, pomodorini, rukola pas pjekjes",
    ingIta: "Salsa di pomodoro, mozzarella, bresaola, burrata, pomodorini, rucola dopo la cottura",
    ingEng: "Tomato sauce, mozzarella, bresaola, burrata, cherry tomatoes, arugula after baking",
    price: "1200",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 73,
    alb: "Braccio Di Ferro",
    ita: "Braccio Di Ferro",
    eng: "Braccio Di Ferro",
    ingAlb: "Salcë domatesh, mozzarella, radicchio, salçiçe e freskët, grana",
    ingIta: "Salsa di pomodoro, mozzarella, radicchio, salsiccia fresca, grana",
    ingEng: "Tomato sauce, mozzarella, radicchio, fresh sausage, grana",
    price: "1000",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 74,
    alb: "Mortadella Pistacchio",
    ita: "Mortadella Pistacchio",
    eng: "Mortadella Pistachio",
    ingAlb: "Salcë domatesh, mozzarella, mortadella pas pjekjes, burrata, pistacchio",
    ingIta: "Salsa di pomodoro, mozzarella, mortadella dopo la cottura, burrata, pistacchio",
    ingEng: "Tomato sauce, mozzarella, mortadella after baking, burrata, pistachio",
    price: "1250",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 75,
    alb: "Salcice Italiane",
    ita: "Salsiccia Italiana",
    eng: "Italian Sausage",
    ingAlb: "Salcë, mozzarella, salcice e freskët, kërpudhë, gorgonzola, pomodorini",
    ingIta: "Salsa, mozzarella, salsiccia fresca, funghi, gorgonzola, pomodorini",
    ingEng: "Sauce, mozzarella, fresh sausage, mushrooms, gorgonzola, cherry tomatoes",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 76,
    alb: "Mortadella",
    ita: "Mortadella",
    eng: "Mortadella",
    ingAlb: "Salcë domatesh, mozzarella, mortadella pas pjekjes, burrata, rukola pas pjekjes",
    ingIta: "Salsa di pomodoro, mozzarella, mortadella dopo la cottura, burrata, rucola dopo la cottura",
    ingEng: "Tomato sauce, mozzarella, mortadella after baking, burrata, arugula after baking",
    price: "1200",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 77,
    alb: "Gusto Di Manzo",
    ita: "Gusto di Manzo",
    eng: "Beef Taste",
    ingAlb: "Salcë domatesh, mozzarella, salcice e freskët viçi",
    ingIta: "Salsa di pomodoro, mozzarella, salsiccia fresca di manzo",
    ingEng: "Tomato sauce, mozzarella, fresh beef sausage",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 78,
    alb: "Pica LOCA",
    ita: "Pizza LOCA",
    eng: "LOCA Pizza",
    ingAlb: "Salcë domatesh, mozzarella, sallam pikant, kërpudhë, filadelfia, pika tartufi",
    ingIta: "Salsa di pomodoro, mozzarella, salame piccante, funghi, philadelphia, gocce di tartufo",
    ingEng: "Tomato sauce, mozzarella, spicy salami, mushrooms, Philadelphia, truffle drops",
    price: "1000",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
{
    id: 79,
    alb: "4 Djathrat",
    ita: "4 Formaggi",
    eng: "4 Cheeses",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 80,
    alb: "Colosseo",
    ita: "Colosseo",
    eng: "Colosseo",
    ingAlb: "Mozzarella, scamorza, kungull, grana, proshutë krudo",
    ingIta: "Mozzarella, scamorza, zucca, grana, prosciutto crudo",
    ingEng: "Mozzarella, scamorza, pumpkin, grana, prosciutto crudo",
    price: "900",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 81,
    alb: "Piemontese",
    ita: "Piemontese",
    eng: "Piemontese",
    ingAlb: "Mozzarella, gorgonzola, speck, grana",
    ingIta: "Mozzarella, gorgonzola, speck, grana",
    ingEng: "Mozzarella, gorgonzola, speck, grana",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
{
    id: 82,
    alb: "Tersina",
    ita: "Tersina",
    eng: "Tersina",
    ingAlb: "Salcë domatesh, pâté tartufi, mozzarella, sallam pikant, kërpudhë e freskët, pomodorini",
    ingIta: "Salsa di pomodoro, pâté di tartufo, mozzarella, salame piccante, funghi freschi, pomodorini",
    ingEng: "Tomato sauce, truffle pâté, mozzarella, spicy salami, fresh mushrooms, cherry tomatoes",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 83,
    alb: "Tartufami",
    ita: "Tartufami",
    eng: "Tartufami",
    ingAlb: "Pâté tartufi, mozzarella, sallam pikant, karçof, gorgonzola",
    ingIta: "Pâté di tartufo, mozzarella, salame piccante, carciofi, gorgonzola",
    ingEng: "Truffle pâté, mozzarella, spicy salami, artichoke, gorgonzola",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 84,
    alb: "Tartufata",
    ita: "Tartufata",
    eng: "Tartufata",
    ingAlb: "Pâté tartufi, mozzarella, pançetë, kërpudhë e freskët, pomodorini",
    ingIta: "Pâté di tartufo, mozzarella, pancetta, funghi freschi, pomodorini",
    ingEng: "Truffle pâté, mozzarella, pancetta, fresh mushrooms, cherry tomatoes",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 85,
    alb: "Con Speck",
    ita: "Con Speck",
    eng: "Con Speck",
    ingAlb: "Pâté tartufi, mozzarella, kërpudhë e freskët, speck, grana",
    ingIta: "Pâté di tartufo, mozzarella, funghi freschi, speck, grana",
    ingEng: "Truffle pâté, mozzarella, fresh mushrooms, speck, grana",
    price: "950",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 86,
    alb: "Vasco Da Gamma",
    ita: "Vasco Da Gamma",
    eng: "Vasco Da Gamma",
    ingAlb: "Pâté tartufi, mozzarella, radicchio, salçiçe e freskët, burrata",
    ingIta: "Pâté di tartufo, mozzarella, radicchio, salsiccia fresca, burrata",
    ingEng: "Truffle pâté, mozzarella, radicchio, fresh sausage, burrata",
    price: "1200",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 87,
    alb: "4 Gusti",
    ita: "4 Gusti",
    eng: "4 Flavors",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "1200",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
 {
    id: 67,
    alb: "Proshutë Kërpudhë",
    ita: "Prosciutto E Funghi",
    eng: "Ham & Mushrooms",
    ingAlb: "Mozzarella, Proshutë, Kërpudhë",
    ingIta: "Mozzarella, Prosciutto, Funghi",
    ingEng: "Mozzarella, Ham, Mushrooms",
    price: "800",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
  {
    id: 68,
    alb: "Perime",
    ita: "Verdure",
    eng: "Vegetables",
    ingAlb: "Mozzarella, Miks Perimesh Zgare",
    ingIta: "Mozzarella, Misto Di Verdure Alla Griglia",
    ingEng: "Mozzarella, Mix Vegetable Grill",
    price: "750",
    kat: 8,
    linkAlb: "/pizza",
    linkIta: "/pizza-ita",
    linkEng: "/pizza-eng",
  },
];

export const baguetteItems = [
  {
    id: 64,
    alb: "Brie",
    ita: "Brie",
    eng: "Brie",
    ingAlb: "Mozzarella, Brie, Kunguj, Pas Pjekjes Rukola, Proshutë Cotto",
    ingIta:
      "Mozzarella, Brie, Zucce, Doppo La Cottura Rucola, Prosciutto Cotto",
    ingEng: "Mozzarella, Brie, Pumpkin, After Baking Arugula, Cotto",
    price: "900",
    kat: 5,
    linkAlb: "/baguette",
    linkIta: "/baguette-ita",
    linkEng: "/baguette-eng",
  },
  {
    id: 65,
    alb: "Gusto",
    ita: "Gusto",
    eng: "Gusto",
    ingAlb: "Mozzarella, Ricotta, Proshutë Krudo Rukola, Granna",
    ingIta: "Mozzarella, Ricotta, Prosciutto Crudo, Rucola, Granna",
    ingEng: "Mozzarella, Ricotta, Crudo, Arugula, Granna",
    price: "800",
    kat: 5,
    linkAlb: "/baguette",
    linkIta: "/baguette-ita",
    linkEng: "/baguette-eng",
  },
];
export const conchasItems = [
  {
    id: 72,
    alb: "Conchas Mediterranea",
    ita: "Conchas Mediterranea",
    eng: "Conchas Mediterranea",
    ingAlb: "Mozzarella, Kërpudhë E Freskët, Speck Dhe Granna Pas Pjekjes",
    ingIta: "Mozzarella, Funghi Freschi, Speck E Granna Doppo La Cottura",
    ingEng: "Mozzarella, Fresh Mushrooms, Speck And Granna After Baking",
    price: "850",
    kat: 7,
    linkAlb: "/conchas",
    linkIta: "/conchas-ita",
    linkEng: "/conchas-eng",
  },
  {
    id: 74,
    alb: "Conchas Pikante",
    ita: "Conchas Piccante",
    eng: "Conchas Spicy",
    ingAlb: "Mozzarella, Sallam Pikant, Gorgonzola",
    ingIta: "Mozzarella, Salamino Picante, Gorgonzola",
    ingEng: "Mozzarella, Spicy Salami, Gorgonzola",
    price: "850",
    kat: 7,
    linkAlb: "/conchas",
    linkIta: "/conchas-ita",
    linkEng: "/conchas-eng",
  },
];
export const calzoneItems = [
  {
    id: 67,
    alb: "Proshutë Kërpudhë",
    ita: "Prosciutto E Funghi",
    eng: "Ham & Mushrooms",
    ingAlb: "Mozzarella, Proshutë, Kërpudhë",
    ingIta: "Mozzarella, Prosciutto, Funghi",
    ingEng: "Mozzarella, Ham, Mushrooms",
    price: "800",
    kat: 6,
    linkAlb: "/calzone",
    linkIta: "/calzone-ita",
    linkEng: "/calzone-eng",
  },
  {
    id: 68,
    alb: "Perime",
    ita: "Verdure",
    eng: "Vegetables",
    ingAlb: "Mozzarella, Miks Perimesh Zgare",
    ingIta: "Mozzarella, Misto Di Verdure Alla Griglia",
    ingEng: "Mozzarella, Mix Vegetable Grill",
    price: "750",
    kat: 6,
    linkAlb: "/calzone",
    linkIta: "/calzone-ita",
    linkEng: "/calzone-eng",
  },
{
    id: 92,
    alb: "Calzone Chef",
    ita: "Calzone Chef",
    eng: "Chef's Calzone",
    ingAlb: "Salcë domatesh, mozzarella, proshutë pas pjekjes, filadelfia, pistacchio",
    ingIta: "Salsa di pomodoro, mozzarella, prosciutto dopo la cottura, philadelphia, pistacchio",
    ingEng: "Tomato sauce, mozzarella, ham after baking, Philadelphia, pistachio",
    price: "950",
    kat: 6,
    linkAlb: "/calzone",
    linkIta: "/calzone-ita",
    linkEng: "/calzone-eng",
  },
];
export const embelsiraItems = [
    {
    id: 128,
    alb: "Dopio Mozzarella",
    ita: "Doppia Mozzarella",
    eng: "Double Mozzarella",
    price: "200",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 129,
    alb: "Salcice e Freskët",
    ita: "Salsiccia Fresca",
    eng: "Fresh Sausage",
    price: "200",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 130,
    alb: "Burrata",
    ita: "Burrata",
    eng: "Burrata",
    price: "450",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 131,
    alb: "Cotto",
    ita: "Prosciutto Cotto",
    eng: "Cooked Ham",
    price: "200",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 132,
    alb: "Sallam Pikant",
    ita: "Salame Piccante",
    eng: "Spicy Salami",
    price: "200",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 133,
    alb: "Grana",
    ita: "Grana",
    eng: "Grana",
    price: "100",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 134,
    alb: "Karrota, Bizele, Spinaq Sote",
    ita: "Carote, Piselli, Spinaci Saltati",
    eng: "Sautéed Carrots, Peas & Spinach",
    price: "300",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 135,
    alb: "Brokoli Sote",
    ita: "Broccoli Saltati",
    eng: "Sautéed Broccoli",
    price: "300",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
  {
    id: 136,
    alb: "Panxhar Sote",
    ita: "Barbabietola Saltata",
    eng: "Sautéed Beetroot",
    price: "300",
    kat: 12,
    linkAlb: "/embelsira",
    linkIta: "/dolci",
    linkEng: "/desserts",
  },
];
export const pijeItems = [
{
    id: 93,
    alb: "Coca Cola",
    ita: "Coca Cola",
    eng: "Coca Cola",
    ingAlb: "",
    ingIta: "",
    ingEng: "",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 94,
    alb: "Fanta",
    ita: "Fanta",
    eng: "Fanta",
    ingAlb: "Portokall, Exotic",
    ingIta: "Arancia, Exotic",
    ingEng: "Orange, Exotic",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 95,
    alb: "Sprite",
    ita: "Sprite",
    eng: "Sprite",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 96,
    alb: "Schweps",
    ita: "Schweppes",
    eng: "Schweppes",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 97,
    alb: "Soda",
    ita: "Soda",
    eng: "Soda",
    ingAlb: "Orange, Lemon",
    ingIta: "Arancia, Limone",
    ingEng: "Orange, Lemon",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 98,
    alb: "Bravo",
    ita: "Bravo",
    eng: "Bravo",
    ingAlb: "Mollë, Pjeshkë, Rrush, Luleshtrydhe",
    ingIta: "Mela, Pesca, Uva, Fragola",
    ingEng: "Apple, Peach, Grape, Strawberry",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 99,
    alb: "Çaj i Ftohtë",
    ita: "Tè Freddo",
    eng: "Iced Tea",
    ingAlb: "Pjeshkë, Limon",
    ingIta: "Pesca, Limone",
    ingEng: "Peach, Lemon",
    price: "220",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 100,
    alb: "Red Bull",
    ita: "Red Bull",
    eng: "Red Bull",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 101,
    alb: "Lëng Portokalli",
    ita: "Succo d'Arancia",
    eng: "Orange Juice",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 102,
    alb: "Rose Lemonade (Fentimans)",
    ita: "Rose Lemonade (Fentimans)",
    eng: "Rose Lemonade (Fentimans)",
    price: "500",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 103,
    alb: "Ujë Natyral 0.75l",
    ita: "Acqua Naturale 0.75l",
    eng: "Still Water 0.75l",
    price: "250",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 104,
    alb: "Ujë i Gazuar 0.75l",
    ita: "Acqua Frizzante 0.75l",
    eng: "Sparkling Water 0.75l",
    price: "250",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 105,
    alb: "Ujë Natyral 0.5l",
    ita: "Acqua Naturale 0.5l",
    eng: "Still Water 0.5l",
    price: "120",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 106,
    alb: "Ujë i Gazuar 0.5l",
    ita: "Acqua Frizzante 0.5l",
    eng: "Sparkling Water 0.5l",
    price: "120",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 107,
    alb: "Acqua Panna 0.75l",
    ita: "Acqua Panna 0.75l",
    eng: "Acqua Panna 0.75l",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 108,
    alb: "Acqua SanPellegrino 0.75l",
    ita: "Acqua SanPellegrino 0.75l",
    eng: "Acqua SanPellegrino 0.75l",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
 {
    id: 109,
    alb: "Birrë Kriko 0.25l",
    ita: "Birra alla Spina 0.25l",
    eng: "Draft Beer 0.25l",
    price: "250",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 110,
    alb: "Birrë Kriko 0.5l",
    ita: "Birra alla Spina 0.5l",
    eng: "Draft Beer 0.5l",
    price: "480",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 111,
    alb: "Birrë Shqiptare",
    ita: "Birra Albanese",
    eng: "Albanian Beer",
    price: "320",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 112,
    alb: "Heineken",
    ita: "Heineken",
    eng: "Heineken",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 113,
    alb: "Stella Artois",
    ita: "Stella Artois",
    eng: "Stella Artois",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 114,
    alb: "Birrë Paulaner",
    ita: "Birra Paulaner",
    eng: "Paulaner Beer",
    ingAlb: "E turbullt",
    ingIta: "Non filtrata",
    ingEng: "Unfiltered",
    price: "450",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
 {
    id: 115,
    alb: "Gotë Verë e Bardhë dhe e Kuqe Shishe (Pinot & Montepulciano)",
    ita: "Calice di Vino Bianco e Rosso (Pinot & Montepulciano)",
    eng: "Glass of White & Red Wine (Pinot & Montepulciano)",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
 {
    id: 116,
    alb: "Aperol Spritz",
    ita: "Aperol Spritz",
    eng: "Aperol Spritz",
    price: "450",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
 {
    id: 117,
    alb: "Limoncello",
    ita: "Limoncello",
    eng: "Limoncello",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 118,
    alb: "Bombay",
    ita: "Bombay",
    eng: "Bombay",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 119,
    alb: "Hendrick's",
    ita: "Hendrick's",
    eng: "Hendrick's",
    price: "600",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 120,
    alb: "Disarono",
    ita: "Disaronno",
    eng: "Disaronno",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 121,
    alb: "Montenegro",
    ita: "Montenegro",
    eng: "Montenegro",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 122,
    alb: "Amaro del Capo",
    ita: "Amaro del Capo",
    eng: "Amaro del Capo",
    price: "400",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 123,
    alb: "Jameson",
    ita: "Jameson",
    eng: "Jameson",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 124,
    alb: "Chivas",
    ita: "Chivas",
    eng: "Chivas",
    price: "450",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 125,
    alb: "Vecchia Romagna",
    ita: "Vecchia Romagna",
    eng: "Vecchia Romagna",
    price: "350",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 126,
    alb: "Hennessy",
    ita: "Hennessy",
    eng: "Hennessy",
    price: "550",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
  {
    id: 127,
    alb: "Vodka Grey Goose",
    ita: "Vodka Grey Goose",
    eng: "Grey Goose Vodka",
    price: "600",
    kat: 14,
    linkAlb: "/pijet",
    linkIta: "/bevande",
    linkEng: "/drinks",
  },
];